import React from 'react'

import NoxsysSchemeImg from './img/home_noxsys_scheme.png'

export const NoxsysSolution: React.FC = () => {
    return (
        <div className="w-full lg:w-[940px]">
            <h1 className="font-bold text-2xl mt-10 text-center">
                Решение в NOXSYS
            </h1>
            <div className="flex flex-col md:flex-row mt-4 items-center gap-4">
                <div className="md:flex-1 text-lg md:text-2xl font-bold text-center md:text-start">
                    В системе NOXSYS автоматизированы все стадии организации
                    закупок
                </div>
                <div className="md:flex-1 flex flex-col gap-4">
                    <div className="card_item card_item_light">
                        <b>Планирование закупок</b>
                        <br />
                        Создание, изменение, аннулирование и копирование позиций
                        плана закупки
                    </div>
                    <div className="card_item card_item_light">
                        <b>Организация закупок</b>
                        <br />
                        Проверьте и согласуйте каждую позицию плана закупки
                    </div>
                    <div className="card_item card_item_light">
                        <b>Согласование всех процессов</b>
                        <br />
                        Консолидация планов подразделений в единый план закупки
                        организации для размещения в ЕИС
                    </div>
                    <div className="card_item card_item_light">
                        <b>Ведение договоров</b>
                        <br />
                        Автоматический обмен данными с ЕИС. Отправьте план
                        закупки в ЕИС – одним кликом
                    </div>
                    <div className="card_item card_item_light">
                        <b>Исполнение договоров</b>
                        <br />
                        Больше никакого ручного ввода данных в ЕИС – все данные
                        автоматически отправляются из системы
                    </div>
                </div>
            </div>
            <div className="flex flex-col md:flex-row w-full gap-4 items-center mt-10">
                <div className="flex-1">
                    <img src={NoxsysSchemeImg} />
                </div>
                <div className="flex-1 text-lg md:text-2xl font-bold text-center md:text-start order-first md:order-none">
                    NOXSYS - единая система по закупкам вашей компании
                </div>
            </div>
            <div className="flex flex-row w-full gap-4 items-center mt-10">
                <div className="flex-1 text-lg md:text-2xl font-bold">
                    Индивидуальные настройки под Положение о закупках товаров,
                    работ, услуг
                </div>
                <div className="flex-1">
                    <div className="card_item card_item_light min-h-[200px] flex items-center">
                        <p className="w-full text-center">
                            <b>Индивидуальные настройки</b>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
